import { mapActions } from 'vuex';
import Events from '_utils/events';
import QuotationService from '_services/rest/modules/quotation';

export default {
  name: 'quotation-delete',
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
    },
    deleteRow() {
      this.setToggle({ type: 'progress', bool: true });
      QuotationService.deleteQuotation(this.selectedQuotation)
        .then(() => {
          this.close();
          this.$router.push('/admin/orcamentos/lista/1');
          Events.$emit('update:pagination', false);
          this.activeAlert({ message: 'Orçamento deletado com sucesso', theme: 'success' });
        })
        .catch(error => this.activeAlert({ message: error.message, theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
};
